/**
 * @generated SignedSource<<cbd4b01ef32600d88296d95b17a93e56>>
 * @relayHash d4ff00f1382bdce8b9f253b1949b1290
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e7081399d2f20e531d1fe319a6e4447244e098bbaea7bc48a318648f0dc4b677

import type { ConcreteRequest } from 'relay-runtime';
export type tenantVizGetActivationIdsQuery$variables = {
  cloudId: string;
};
export type tenantVizGetActivationIdsQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIds: ReadonlyArray<{
      readonly active: string | null;
      readonly product: string | null;
    }> | null;
  } | null> | null;
};
export type tenantVizGetActivationIdsQuery = {
  response: tenantVizGetActivationIdsQuery$data;
  variables: tenantVizGetActivationIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "cloudIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIds",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "product"
          },
          {
            "kind": "ScalarField",
            "name": "active"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "tenantVizGetActivationIdsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tenantVizGetActivationIdsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e7081399d2f20e531d1fe319a6e4447244e098bbaea7bc48a318648f0dc4b677",
    "metadata": {},
    "name": "tenantVizGetActivationIdsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fd182b11ab0a2e93e1aa7729d0553268";

export default node;
